import React, { Component } from "react";
import service from "./service";
import {
  Layout,
  notification,
  Row,
  Spin,
  Table,
  Col,
  Select,
  Button,
  Modal,
} from "antd";
import EntryForm from "./form";
import columns from "./column";
import RadioGroup from "antd/lib/radio/group";
import RadioButton from "antd/lib/radio/radioButton";

const { Content } = Layout;
class MemberCountry extends Component {
  state = {
    loading: true,
    listDataSource: [],
    logsDataSource: [],
    countryList: [],
    memberId: 0,

    listTotalRows: 0,
    logsTotalRows: 0,

    modalVisible: false,
  };

  listTable = {
    currentPage: 1,
    currentSearch: "",
    limit: 5,
  };

  logsTable = {
    currentPage: 1,
    currentSearch: "",
    limit: 5,
  };

  async componentDidMount() {
    const { params } = this.props.match;
    const { member_id } = params;

    const search = `{"member_id":${member_id}}`;
    const countryList = await service._loadCountryList();

    // ? load list table
    await this._loadListTable(search, countryList);

    // ? logs table
    await this._loadLogsTable(search, countryList);
  }

  changePageList = async (page, limit) => {
    this.setState({ loading: true });
    this.listTable.currentPage = page;
    this.listTable.limit = limit;

    await this._loadListTable(
      this.listTable.currentSearch,
      this.state.countryList
    );
  };

  changePageLogs = async (page, limit) => {
    this.setState({ loading: true });
    this.logsTable.currentPage = page;
    this.logsTable.limit = limit;

    await this._loadLogsTable(
      this.logsTable.currentSearch,
      this.state.countryList
    );
  };

  formSubbmit = async (payload) => {
    this.setState({ loading: true });
    const result = await service.submitForm(payload);

    this.setState({ loading: false });
    this._handleResponse(result);
  };

  formUpdate = async (payload) => {
    this.setState({ loading: true });
    const result = await service.submitFormUpdate(payload);
    this.setState({ loading: false });
    this._handleResponse(result);
  };

  _loadListTable = async (search, countryList) => {
    // ? list table
    const resp = await service.loadMemberCountryList(
      search,
      this.listTable.currentPage,
      this.listTable.limit,
      countryList
    );

    if (resp.total_rows > 0 && resp.data.length === 0) {
      this.changePageList(1, this.listTable.limit);
      this.setState({ loading: false });
    }

    this.setState({
      loading: false,
      listDataSource: resp.data,
      countryList: countryList,
      listTotalRows: resp.total_rows,
    });

    this.listTable.currentSearch = search;
  };

  _loadLogsTable = async (search, countryList) => {
    const resp = await service.loadMemberCountryLogsList(
      search,
      this.logsTable.currentPage,
      this.logsTable.limit,
      countryList
    );

    if (resp.total_rows > 0 && resp.data.length === 0) {
      this.changePageLogs(1, this.logsTable.limit);
      this.setState({ loading: false });
    }

    this.setState({
      loading: false,
      logsDataSource: resp.data,
      logsTotalRows: resp.total_rows,
    });

    this.logsTable.currentSearch = search;
  };

  _handleResponse = (result) => {
    this.changePageList(this.listTable.page, this.listTable.limit);

    if (!result.result) {
      notification.error({
        message: result.error["name"],
        description: result.error["description"],
      });
      return;
    }

    notification.success({
      message: "The entry form has succeed",
    });

    // ? load both list
    this._loadListTable(this.listTable.currentSearch, this.state.countryList);
    this._loadLogsTable(this.logsTable.currentSearch, this.state.countryList);
  };

  _onChangeSearch = async (v) => {
    const tmp = this.listTable;

    // ? parse search
    const jsonSearch = JSON.parse(tmp.currentSearch);
    delete jsonSearch["region_code"];

    if (v) {
      jsonSearch["region_code"] = v;
    }

    tmp.currentSearch = JSON.stringify(jsonSearch);
    this.listTable = tmp;

    this.setState({ loading: true });

    await this._loadListTable(
      this.listTable.currentSearch,
      this.state.countryList
    );
  };

  _onConfirmAllow = async () => {
    this.setState({ loading: true });
    const { member_id } = this.props.match.params;
    const payload = {
      member_id: Number(member_id),
    };

    const result = await service.allowAggregator(payload);
    this.setState({ loading: false, modalVisible: false });
    this._handleResponse(result);
  };

  _onCloseAllow = () => {
    this.setState({ modalVisible: false });
  };

  _handleOnFilterRest = async (val) => {
    const tmp = this.listTable;

    // ? parse search
    const jsonSearch = JSON.parse(tmp.currentSearch);
    delete jsonSearch["restriction"];

    if (val !== -1) {
      jsonSearch["restriction"] = val;
    }

    tmp.currentSearch = JSON.stringify(jsonSearch);
    this.listTable = tmp;

    this.setState({ loading: true });

    await this._loadListTable(
      this.listTable.currentSearch,
      this.state.countryList
    );
  };

  render() {
    const { member_id } = this.props.match.params;
    const listTable = {
      className: "my-table",
      columns: columns.listColumn(this.formUpdate),
      dataSource: this.state.listDataSource,
      rowKey: "id",
      title: () => (
        <Row gutter={8} type="flex">
          <Col xl={8}>
            <Select
              showSearch
              allowClear
              placeholder="Search Country"
              style={{ width: "100%" }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0 ||
                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
              }
              onChange={(v) => this._onChangeSearch(v)}
            >
              {this.state.countryList.map((c) => {
                const { region_code, name } = c;
                if (region_code === "NONE") {
                  return null;
                }
                return (
                  <Option key={region_code} value={region_code}>
                    {name}
                  </Option>
                );
              })}
            </Select>
          </Col>
          <Col style={{ textAlign: "end" }} xl={14}>
            Allowance Filter :
            <RadioGroup
              style={{ marginLeft: "5px" }}
              buttonStyle="outline"
              defaultValue={-1}
              onChange={({ target }) => this._handleOnFilterRest(target.value)}
            >
              <RadioButton value={-1}>ALL</RadioButton>
              <RadioButton value={2}>YES</RadioButton>
              <RadioButton value={1}>NO</RadioButton>
            </RadioGroup>
          </Col>
        </Row>
      ),
      pagination: {
        pageSize: this.listTable.limit,
        total: this.state.listTotalRows,
        current: this.listTable.currentPage,
        onChange: this.changePageList,
        size: "small",
      },
    };

    const logsTable = {
      className: "log-table",
      columns: columns.logsColumn,
      dataSource: this.state.logsDataSource,
      rowKey: "id",
      title: () => <p>Event Logs</p>,
      pagination: {
        pageSize: this.logsTable.limit,
        total: this.state.logsTotalRows,
        current: this.logsTable.currentPage,
        onChange: this.changePageLogs,
        size: "small",
      },
    };

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <EntryForm
            memberId={member_id}
            countryList={this.state.countryList}
            onSubmit={this.formSubbmit}
          />
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 50,
            }}
          >
            <Row gutter={16}>
              <Col xl={20}>
                *อนุญาติให้ลูกค้าคนนี้สามารถส่งไปยังประเทศที่ `disabled`
                ในขณะนี้ได้ทั้งหมด (สำหรับ Aggregator)
              </Col>
              <Col xl={4}>
                <Button
                  type="danger"
                  onClick={() => this.setState({ modalVisible: true })}
                >
                  Allow Restricted Country
                </Button>
              </Col>
            </Row>
          </Content>
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 450,
            }}
          >
            <Row gutter={16}>
              <Col xl={12}>
                <Table {...listTable} />
              </Col>
              <Col xl={12}>
                <Table {...logsTable} />
              </Col>
            </Row>
          </Content>
        </Spin>
        <Modal
          title="คุณแน่ใจใช่ไหม?"
          visible={this.state.modalVisible}
          onOk={this._onConfirmAllow}
          onCancel={this._onCloseAllow}
        >
          คุณยืนยันที่จะให้ลูกค้าท่านนี้สามารถที่จะส่งข้อความไปยัง Restricted
          Country ใช่หรือไม่?
        </Modal>
      </Layout>
    );
  }
}

export default MemberCountry;



// WEBPACK FOOTER //
// ./src/containers/MemberCountry/index.js